import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { notification } from "antd";
import RoleService from "services/RoleService";
export const initialState = {
  data: [],
  dataDetail: [],
  dataSelect: [],
  dataDelete: null,
  loading: false,
  error: null,
  redirect: false,
  status: false,
};

export const fetchRoleData = createAsyncThunk(
  "role/fetchRoleData",
  async (data, { rejectWithValue }) => {
    try {
      const { page, pageSize, sort, searchText, state } = data;
      const response = await RoleService.get({
        page,
        pageSize,
        sort,
        searchText,
        state,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Error");
    }
  }
);

export const fetchRoleDataSelect = createAsyncThunk(
  "role/fetchRoleDataSelect",
  async (_, { rejectWithValue }) => {
    try {
      const response = await RoleService.getDataSelect();
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Error");
    }
  }
);

export const fetchRoleDetail = createAsyncThunk(
  "role/fetchRoleDetail",
  async (id, { rejectWithValue }) => {
    try {
      const response = await RoleService.getById(id);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const createRoleData = createAsyncThunk(
  "role/createRoleData",
  async (data, { rejectWithValue }) => {
    try {
      const { name, menu } = data;
      const response = await RoleService.createRole({
        name,
        menu,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const updateRoleData = createAsyncThunk(
  "role/updateRoleData",
  async (data, { rejectWithValue }) => {
    try {
      const { id, name, menu } = data;
      const response = await RoleService.updateRole({
        id,
        name,
        menu,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const deleteRoleData = createAsyncThunk(
  "role/deleteRoleData",
  async (data, { rejectWithValue }) => {
    try {
      const { id, confirm } = data;
      const response = await RoleService.deleteRole(id, confirm);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const roleSlice = createSlice({
  name: "role",
  initialState,
  reducers: {
    resetDataDeleteRole: (state) => {
      state.dataDelete = null;
    },
    showLoading: (state) => {
      state.loading = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRoleData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchRoleData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
      })
      .addCase(fetchRoleData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchRoleDataSelect.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchRoleDataSelect.fulfilled, (state, action) => {
        state.loading = false;
        state.dataSelect = action.payload.data;
      })
      .addCase(fetchRoleDataSelect.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchRoleDetail.pending, (state) => {
        state.loading = true;
        state.status = false;
        state.redirect = false;
      })
      .addCase(fetchRoleDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.dataDetail = action.payload.data;
        state.error = null;
        state.status = true;
      })
      .addCase(fetchRoleDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.status = false;
      })
      .addCase(createRoleData.pending, (state) => {
        state.loading = true;
        state.redirect = false;
      })
      .addCase(createRoleData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.redirect = true;
        notification.success({ message: "Proses Berhasil" });
      })
      .addCase(createRoleData.rejected, (state, action) => {
        state.redirect = false;
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateRoleData.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateRoleData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        notification.success({ message: "Proses Berhasil" });
        state.redirect = true;
      })
      .addCase(updateRoleData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteRoleData.pending, (state) => {
        state.redirect = false;
        state.loading = true;
      })
      .addCase(deleteRoleData.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.status === 200) state.dataDelete = action.payload;
        else {
          state.redirect = true;
          notification.success({ message: "Proses Berhasil" });
        }
      })
      .addCase(deleteRoleData.rejected, (state, action) => {
        state.redirect = false;
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { showLoading, resetDataDeleteRole } = roleSlice.actions;

export default roleSlice.reducer;
